import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import cx from "classnames";
import { Text, TextFontSizes, TextFontWeights, TextLineHeights } from "@cinch-labs/design-system";
import styles from "./finance-lenders.module.css";
import { Wrapper } from "@cinch-nx/shared-ui";
function FinanceLenders({ i18n , className  }) {
    const STATIC_ASSET_DOMAIN = i18n.endpoints.staticAssetBaseUrl;
    const lenders = [
        {
            name: "Black Horse",
            webpSrc: `${STATIC_ASSET_DOMAIN}/finance/bh-logo.webp`,
            fallbackSrc: `${STATIC_ASSET_DOMAIN}/finance/bh-logo.png`
        },
        {
            name: "Evolution Funding",
            webpSrc: `${STATIC_ASSET_DOMAIN}/finance/evo-logo.webp`,
            fallbackSrc: `${STATIC_ASSET_DOMAIN}/finance/evo-logo.png`
        },
        {
            name: "Moto Novo Finance",
            webpSrc: `${STATIC_ASSET_DOMAIN}/finance/moto-novo.webp`,
            fallbackSrc: `${STATIC_ASSET_DOMAIN}/finance/moto-novo.png`
        },
        {
            name: "Santander Consumer Finance",
            webpSrc: `${STATIC_ASSET_DOMAIN}/finance/santander-cf-logo.webp`,
            fallbackSrc: `${STATIC_ASSET_DOMAIN}/finance/santander-cf-logo.png`
        }
    ];
    return /*#__PURE__*/ _jsx("article", {
        className: cx(styles.lendingPartners, className),
        children: /*#__PURE__*/ _jsxs(Wrapper, {
            children: [
                /*#__PURE__*/ _jsx(Text, {
                    element: "h2",
                    fontSize: TextFontSizes["4xl"],
                    fontWeight: TextFontWeights.bold,
                    lineHeight: TextLineHeights.display,
                    className: styles.lendingPartnersMainTitle,
                    children: i18n.title
                }),
                /*#__PURE__*/ _jsx(Text, {
                    fontSize: TextFontSizes.s,
                    fontWeight: TextFontWeights.book,
                    children: i18n.text
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: styles.lenderImagesContainer,
                    children: /*#__PURE__*/ _jsx("ul", {
                        className: styles.lenderImages,
                        children: lenders.map((lender)=>/*#__PURE__*/ _jsx("li", {
                                className: styles.lenderImageItem,
                                children: /*#__PURE__*/ _jsxs("picture", {
                                    className: styles.lenderImageContainer,
                                    children: [
                                        /*#__PURE__*/ _jsx("source", {
                                            srcSet: lender.webpSrc,
                                            type: "image/webp"
                                        }),
                                        /*#__PURE__*/ _jsx("img", {
                                            src: lender.fallbackSrc,
                                            alt: lender.name,
                                            loading: "lazy",
                                            className: styles.lenderImage
                                        })
                                    ]
                                })
                            }, lender.name))
                    })
                })
            ]
        })
    });
}
export default FinanceLenders;
